"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  cargoTracking: {
    title: '货物跟踪',
    blNo: '提单号',
    containerNo: '箱号',
    pickUp: '放箱中',
    outboundCY: '进站中',
    departPOL: '开船',
    berthPOD: '靠泊',
    inboundCY: '卸船',
    release: '换单',
    inboundDelivery: '提货中',
    emptyContainer: '还箱中',
    receivedOrder: '已接单',
    releaseBox: '已放箱',
    sendCar: '已派车',
    ReceivedBox: '已提箱',
    arriveFactory: '已到厂',
    leaveFactory: '已离厂',
    ReturnBox: '已进港/还箱',
    position: '实时定位',
    track: '轨迹回放',
    tips_1: '黑色字体为预计时间|',
    tips_2: ' 红色字体为实际时间'
  }
};